var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.attr.value,"placement":"top-end","effect":"light"}},[_c('div',{staticClass:"attr-item",class:{actived: _vm.actived, disable: _vm.disable},on:{"click":_vm.onClick}},[(_vm.showImg)?_c('img',{staticClass:"w-8 h-8",attrs:{"src":_vm.joinHead(_vm.attr.src),"alt":""}}):[_vm._v(" "+_vm._s(_vm.attr.value)+" ")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }